/*
 * @Descripttion:
 * @version:
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2025-07-14 10:11:08
 * @LastEditors: linxi
 * @LastEditTime: 2025-07-21 13:42:43
 */
import {
  Button,
  Col,
  DatePicker,
  Form,
  Input,
  Modal,
  notification,
  Row,
  Select,
} from 'antd'
import { useDispatch, useSelector } from 'react-redux'
import { RootDispatch } from '../../../app/store'
import React, { useEffect, useState } from 'react'
import {
  DateTimeFormat,
  DateTimeFormatSimple,
  DateTimeFormatSimpleOnly,
  DateTimeFormatSimpleOnlyOne,
  DateTimeFormatSimplePrintCharge,
} from '../../../models/datetime'
import { unwrapResult } from '@reduxjs/toolkit'
import moment from 'moment'
import {
  getPDRecordDetailAsync,
  getPDRecordSubmitAsync,
} from './pharmaceuticalDestructionRecordSlice'
import { getUserList } from '../../user/userSlice'
import { selectUserId } from '../../../app/applicationSlice'
import { ItemCompletionType } from '../../completion/completionSlice'
import { RecipeItemInput } from '../../treatment/editor/components/RecipeItemInput'
import styles from './pharmaceuticalDestructionRecord.module.css'

const { Option } = Select

export const AddOrEditFormModal = (props: {
  flag?: any
  id?: any
  isModalVisible: boolean
  onOk: () => void
  onCancel: () => void
}) => {
  const [form] = Form.useForm()

  const userId = useSelector(selectUserId)

  const dispatch = useDispatch<RootDispatch>()

  const [selectData, setSelectData] = useState<any>()

  const [confirmLoading, setConfirmLoading] = useState(false)

  const [userList, setUserList] = useState<any>()

  const [detail, setDetail] = useState<any>()

  const layout = {
    labelCol: { span: 8 },
    wrapperCol: { span: 15 },
  }

  useEffect(() => {
    if (props.isModalVisible) {
      dispatch(getUserList({ current: 1, size: 1000, state: 1 }))
        .then(unwrapResult)
        .then((res: any) => {
          setUserList(res?.items)
        })
    }
  }, [props.isModalVisible])

  const getDetail = () => {
    dispatch(getPDRecordDetailAsync(props?.id))
      .then(unwrapResult)
      .then((v: any) => {
        setDetail(v)
        setSelectData({ ...v, name: v?.tenantMaterialsName })
        form.setFieldsValue({
          ...v,
          destroyDate: v?.destroyDate ? moment(v?.destroyDate) : undefined,
          periodValidity: v?.periodValidity
            ? moment(v?.periodValidity)
            : undefined,
          destroyUser:
            v?.destroyUser > 0 ? v?.destroyUser?.toString() : undefined,
          superviseUser:
            v?.superviseUser > 0 ? v?.superviseUser?.toString() : undefined,
        })
      })
  }

  useEffect(() => {
    if (props.isModalVisible) {
      if (props?.id) {
        getDetail()
      } else {
        form.setFieldsValue({
          destroyUser: userId?.toString(),
        })
      }
    } else {
      form.resetFields()
      setSelectData('')
      setDetail({})
      setUserList([])
    }
  }, [props.isModalVisible])

  return (
    <Modal
      className={styles.modal}
      width={1000}
      title={props?.flag ? '查看' : props?.id ? '编辑数据' : '添加数据'}
      visible={props.isModalVisible}
      footer={null}
      destroyOnClose
      onCancel={() => {
        props.onCancel()
      }}
      onOk={() => {
        props?.onOk()
      }}
    >
      <Form
        autoComplete='off'
        form={form}
        onFinish={(vs) => {
          setConfirmLoading(true)
          const destroyUserName = userList?.find(
            (v: any) => v?.id == vs?.destroyUser
          )?.name
          const superviseUserName = userList?.find(
            (v: any) => v?.id == vs?.superviseUser
          )?.name

          const destroyDate = vs?.destroyDate
            ? moment(vs?.destroyDate)?.format(DateTimeFormatSimpleOnly)
            : ''

          const commonParam = {
            destroyDate: destroyDate,
            spec: undefined,
            originName: undefined,
            doseCategory: undefined,
            batchNo: undefined,
            unit: undefined,
            supplierName: undefined,
            periodValidity: undefined,
            destroyNumber: vs?.destroyNumber
              ? Number(vs?.destroyNumber)
              : undefined,
            superviseUser: vs?.superviseUser
              ? Number(vs?.superviseUser)
              : undefined,
            destroyUser: vs?.destroyUser ? Number(vs?.destroyUser) : undefined,
          }
          const params = props?.id
            ? {
                ...detail,
                ...vs,
                ...commonParam,
                id: detail?.id,
                tenantMaterialsCatalogId:
                  Number(selectData?.tenantMaterialsCatalogId) ||
                  Number(detail?.tenantMaterialsCatalogId),
                tenantInventoryLedgerId:
                  Number(selectData?.id) || Number(detail?.id),
                destroyUserName: destroyUserName || detail?.destroyUserName,
                superviseUserName:
                  superviseUserName || detail?.superviseUserName,
              }
            : {
                ...vs,
                ...commonParam,
                tenantMaterialsCatalogId: Number(
                  selectData?.tenantMaterialsCatalogId
                ),
                tenantInventoryLedgerId: Number(selectData?.id),
                destroyUserName: destroyUserName,
                superviseUserName: superviseUserName,
              }
          if (vs?.tenantMaterialsName == selectData?.name) {
            if (vs?.destroyUser == vs?.superviseUser) {
              notification.info({
                message: '监督人和销毁人不能是同一个人',
              })
              setConfirmLoading(false)
            } else {
              dispatch(getPDRecordSubmitAsync({ ...params }))
                .then(unwrapResult)
                .then((v: any) => {
                  notification.success({
                    message: '操作成功',
                  })
                })
                .finally(() => {
                  props?.onOk()
                  setConfirmLoading(false)
                })
            }
          } else {
            notification.info({
              message: '商品名称错误，请修改后再保存',
            })
            setConfirmLoading(false)
          }
        }}
      >
        <Row>
          <Col span={12}>
            <Form.Item
              {...layout}
              label='商品名'
              name='tenantMaterialsName'
              rules={[
                {
                  required: true,
                  message: '商品名不能为空',
                },
              ]}
            >
              <RecipeItemInput
                disabled={props?.flag}
                noSetting={true}
                type={ItemCompletionType.Auto}
                filters={false}
                useSpecifiedBatch={true}
                onSelect={(v: any) => {
                  setSelectData(v)
                  form.setFieldsValue({
                    tenantMaterialsName: v?.name,
                    spec: v?.spec,
                    originName: v?.tenantSupplierName,
                    doseCategory: v?.doseCategory,
                    batchNo: v?.batchNo,
                    unit: v?.accountUnit,
                    supplierName: v?.gysName,
                    periodValidity: v?.deadline ? moment(v?.deadline) : '',
                  })
                }}
              />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item {...layout} label='规格' name='spec'>
              <Input placeholder='规格' disabled />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item {...layout} label='厂家' name='originName'>
              <Input placeholder='厂家' disabled />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item {...layout} label='剂型' name='doseCategory'>
              <Input placeholder='剂型' disabled />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item {...layout} label='批号' name='batchNo'>
              <Input placeholder='批号' disabled />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item {...layout} label='单位' name='unit'>
              <Input placeholder='单位' disabled />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item {...layout} name='supplierName' label='供应商'>
              <Input placeholder='供应商' disabled />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item {...layout} label='有效期' name='periodValidity'>
              <DatePicker
                disabled
                style={{ width: '100%' }}
                placeholder='有效期'
                format={DateTimeFormatSimple}
                onChange={() => {
                  return
                }}
              />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              {...layout}
              label='销毁数量'
              name='destroyNumber'
              rules={[
                {
                  required: true,
                  message: '报损数量不能为空',
                },
                {
                  message: '请输入最多带两位小数的数值',
                  pattern: new RegExp(/^[0-9]+((\.)[0-9]{0,2})?$/),
                },
              ]}
            >
              <Input placeholder='销毁数量' disabled={props?.flag} />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item {...layout} label='销毁原因' name='destroyReason'>
              <Input placeholder='销毁原因' disabled={props?.flag} />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item {...layout} label='销毁方式' name='destroyWay'>
              <Input placeholder='销毁方式' disabled={props?.flag} />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item {...layout} label='销毁地址' name='destroyAddress'>
              <Input placeholder='销毁地址' disabled={props?.flag} />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              {...layout}
              label='销毁日期'
              name='destroyDate'
              rules={[
                {
                  required: true,
                  message: '报损日期不能为空',
                },
              ]}
            >
              <DatePicker
                disabled={props?.flag}
                style={{ width: '100%' }}
                placeholder='销毁日期'
                format={DateTimeFormatSimple}
                onChange={() => {
                  return
                }}
              />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item {...layout} label='销毁人' name='destroyUser'>
              <Select placeholder='销毁人' allowClear disabled={props?.flag}>
                {userList?.map((v: any, i: any) => {
                  return (
                    <Option value={v?.id} key={i}>
                      {v?.name}
                    </Option>
                  )
                })}
              </Select>
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item {...layout} label='监督人' name='superviseUser'>
              <Select placeholder='监督人' allowClear disabled={props?.flag}>
                {userList?.map((v: any, i: any) => {
                  return (
                    <Option value={v?.id} key={i}>
                      {v?.name}
                    </Option>
                  )
                })}
              </Select>
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item {...layout} label='备注' name='remark'>
              <Input placeholder='备注' disabled={props?.flag} />
            </Form.Item>
          </Col>
        </Row>
        {props?.flag ? (
          <></>
        ) : (
          <Row
            style={{
              marginTop: '20px',
              display: 'flex',
              justifyContent: 'flex-end',
            }}
          >
            <Button
              type='primary'
              onClick={() => {
                form.submit()
              }}
              style={{ marginRight: '10px' }}
            >
              确定
            </Button>
            <Button
              type='primary'
              ghost
              style={{ marginRight: '10px' }}
              onClick={() => {
                props?.onCancel()
              }}
            >
              取消
            </Button>
          </Row>
        )}
      </Form>
    </Modal>
  )
}
